"use client";
import { youtubeId } from "@/helpers/YoutubeId";
import VideoYouTube from "../VideoYouTube/VideoYouTube";
import Image from "next/image";
import { useState } from "react";

export default function ArticleVideo(props) {
    const { article } = props;

    const [videoClicked, setVideoClicked] = useState(false);

    return (
        <>
            {!videoClicked ? (
                <div
                    className="relative w-full z-0 aspect-w-16 aspect-h-9 rounded-xl overflow-hidden cursor-pointer"
                    onClick={() => setVideoClicked(true)}
                >
                    <Image
                        src={`https://i.ytimg.com/vi/${youtubeId(
                            article.video,
                        )}/hqdefault.jpg`}
                        alt={article.title}
                        fill
                        style={{
                            objectFit: "cover",
                        }}
                        quality={80}
                        priority
                    />
                    <div className="absolute top-0 z-20 left-0 right-0 bottom-0 flex flex-col items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-[110px] h-[110px] text-red-500"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="m10 15l5.19-3L10 9zm11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73"
                            ></path>
                        </svg>
                    </div>
                </div>
            ) : (
                <VideoYouTube
                    video={youtubeId(article.video)}
                    title={article.title}
                />
            )}
        </>
    );
}
